(() => {
  // scripts/sections/newsletter.ts
  document.addEventListener("DOMContentLoaded", () => {
    const newsletter = document.querySelector("[data-newsletter]");
    const toggle = document.querySelector("[data-newsletter-toggle]");
    if (window.location.search.includes("customer_posted=true") && window.location.hash === "#contact_form") {
      if (newsletter) {
        newsletter.classList.add("is-active");
      }
      if (newsletter) {
        const rect = newsletter.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        window.scrollTo({
          top: rect.top + scrollTop - 140,
          behavior: "smooth"
        });
      }
    }
    if (newsletter && toggle) {
      toggle.addEventListener("click", () => {
        newsletter.classList.toggle("is-active");
        const input = newsletter.querySelector('input[type="email"]');
        if (input) {
          input.focus();
        }
      });
    }
  });
})();
